import { Lightning } from "@lightningjs/sdk";
import { Card } from "../../base/Card";
import { FOCUS_TRANSITION } from "../../base/focus";
import { PLAYER_BLUE, playerText } from "./styles";
/** A player control; placeholder buttons deliberately have no selection action. */
export class PlaybackButton extends Lightning.Component {
    constructor() {
        super(...arguments);
        this.emitPress = false;
    }
    static _template() {
        return {
            w: 60,
            h: 60,
            Focus: {
                w: (w) => w,
                h: (h) => h,
                alpha: 0,
                rect: true,
                color: Card.BORDER_COLOR,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
            },
            Label: {
                x: (w) => w / 2,
                y: 30,
                mount: 0.5,
                text: Object.assign(Object.assign({}, playerText("", 32)), { textAlign: "center" }),
            },
            Icon: { x: 30, y: 30, mount: 0.5 },
        };
    }
    set label(label) {
        this.tag("Label").patch({ text: { text: label } });
    }
    set sharedFocus(sharedFocus) {
        this.tag("Focus").visible = !sharedFocus;
    }
    set iconSrc(src) {
        this.tag("Icon").patch({
            x: 16,
            y: 12.5,
            mount: 0,
            w: 35,
            h: 35,
            texture: Lightning.Tools.getSvgTexture(src, 70, 70),
        });
        this.tag("Label").patch({
            x: 61,
            y: 9.376,
            mount: 0,
            text: { textAlign: "left" },
        });
    }
    _focus() {
        this.tag("Focus").setSmooth("alpha", 1, FOCUS_TRANSITION);
        this.tag("Label").setSmooth("color", PLAYER_BLUE, FOCUS_TRANSITION);
        this.tag("Icon").setSmooth("color", PLAYER_BLUE, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Focus").setSmooth("alpha", 0, FOCUS_TRANSITION);
        this.tag("Label").setSmooth("color", 0xffffffff, FOCUS_TRANSITION);
        this.tag("Icon").setSmooth("color", 0xffffffff, FOCUS_TRANSITION);
    }
    _handleEnter() {
        if (this.emitPress)
            this.signal("press");
        return true;
    }
}
export default PlaybackButton;
//# sourceMappingURL=PlaybackButton.js.map